import type { AlgorithmMode, SearchController } from "./SearchController";
import { LinearSearchController } from "./LinearSearchController";
import { BinarySearchController } from "./BinarySearchController";

/**
 * The one place that knows the mapping from a level's `algorithm` field to
 * a concrete SearchController (Phase 04). Adding a third searching
 * algorithm later means adding one branch here and one new controller
 * class — GameRuntime itself never needs to change.
 */
export function createSearchController(mode: AlgorithmMode, values: number[], target: number): SearchController {
  if (mode === "binary-search") {
    return new BinarySearchController(values, target);
  }
  return new LinearSearchController(values, target);
}
